import React, { useState, useEffect } from 'react';
import Hero from 'components/page-home/hero';
import Header from 'components/page-home/header';
import Smoke from 'components/shared/smoke-canvas';
import Visit from 'components/page-home/visit';
import Bong from 'components/page-home/bong';
import CrazySwiper from 'components/page-home/crazy-swiper';
import PurchaseModal from 'components/page-home/purchase-modal';
import s from './home.module.scss';
const symb = Symbol('dopeness');

export default function HomePage({ hash, browser }) {
  var [stage, setStage] = useState(0);
  const [ready, setReady] = useState(false);
  const [positionStyle, setPositionStyle] = useState(hash.replace('#', ''));

  const [modalOn, showModal] = useState(false);
  const [modalOpacity, setModalOpacity] = useState(false);
  window[symb] = stage;
  useEffect(()=>{
    window.swiper_stage_access = stage;
  },[stage])
  const brud = {
    bro:true
    }

    {
      const sym = Symbol('demo');
      const sym2 = Symbol('demo2');
      brud[sym] = {
        dude:'here you go man',
        sym2:'sym2 over here'
      };
    }
  useEffect(() => {
    const swiper = setInterval(() => {
      if (window.Swiper) {
        clearInterval(swiper);
        window.highSwiper = new window.Swiper('.swiper-container', {
          loadPrevNext: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          on:{
            slideChange:()=>{
              setStage(window.highSwiper.activeIndex)
            }
          },
          effect: 'fade',
        });
        const { bullets } = window.highSwiper.pagination;
        for (let i = 0; i < bullets.length; i++) {
          bullets[i].addEventListener('click', () => {
            window.highSwiper.slideTo(i);
            setStage(i);
          });
        }
      }
    });
  }, []);


  const setModalOn = () => {
    showModal(true);
    setTimeout(() => {
      setModalOpacity(true);
    }, 0);
  };

  const setModalOff = () => {
    setModalOpacity(false);
    setTimeout(() => {
      showModal(false);
    }, 1000);
  };

  useEffect(() => {
    setReady(true);
    if (hash === '#exhibits-ritual') setPositionStyle('exhibitsRitual');
    else setPositionStyle(hash.replace('#', ''));
  }, [hash]);

  useEffect(()=>{
  },[positionStyle]);

useEffect(()=>{
},[stage])

  return (
    <main className={s.main}>
      <Header stage={stage} hash={hash} setModalOn={setModalOn} />
      <div className={`${s.scroller} ${ready ? s[positionStyle] : ''}`}>
        <Hero setModalOn={setModalOn} browser={browser} />
        <CrazySwiper hash={hash} setModalOn={setModalOn} stage={stage} setStage={setStage} browser={browser}/>
        <Visit setModalOn={setModalOn} isSafari={browser} />

        {modalOn ? <PurchaseModal opacity={modalOpacity} setModalOff={setModalOff} /> : null}
      </div>
    </main>
  );
}
